"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$any = exports.anyToLines = void 0;
const factory_1 = require("../factory");
const line_1 = require("../../../node/cst/line");
const std_1 = require("../../../law/std");
const std = __importStar(require("../../../law/std"));
const toCSTSettings_1 = __importDefault(require("../toCSTSettings"));
const inline_1 = require("../../../node/cst/inline");
const util_1 = require("../../../util");
const _remarks_1 = __importStar(require("./$remarks"));
const _amendProvision_1 = require("./$amendProvision");
const _arithFormula_1 = __importStar(require("./$arithFormula"));
const _article_1 = __importStar(require("./$article"));
const _paragraphItem_1 = require("./$paragraphItem");
const _figStruct_1 = __importStar(require("./$figStruct"));
const _list_1 = require("./$list");
const _noteLike_1 = require("./$noteLike");
const _preamble_1 = __importStar(require("./$preamble"));
const _tableStruct_1 = __importStar(require("./$tableStruct"));
const columnsOrSentences_1 = require("./columnsOrSentences");
const _articleGroup_1 = __importDefault(require("./$articleGroup"));
const anyToLines = (any, indentTexts) => {
    const lines = [];
    if (typeof any === "string" || (0, inline_1.isSentenceChildEL)(any)) {
        lines.push(new line_1.OtherLine({
            range: null,
            indentTexts,
            controls: [],
            sentencesArray: [
                new inline_1.Sentences("", null, [], [(0, std_1.newStdEL)("Sentence", {}, [any])]),
            ],
            lineEndText: toCSTSettings_1.default.EOL,
        }));
    }
    else if (std.isAmendProvision(any)) {
        return (0, _amendProvision_1.amendProvisionToLines)(any, indentTexts);
    }
    else if (std.isArithFormula(any)) {
        return (0, _arithFormula_1.arithFormulaToLines)(any, indentTexts);
    }
    else if (std.isArticle(any)) {
        return (0, _article_1.articleToLines)(any, indentTexts);
    }
    // else if (std.isArticleGroup(any)) { return articleGroupToLines(any, indentTexts); }
    else if (std.isFig(any)) {
        return (0, _figStruct_1.figToLines)(any, indentTexts);
    }
    else if (std.isFigStruct(any)) {
        return (0, _figStruct_1.figStructToLines)(any, indentTexts);
    }
    else if (std.isListOrSublist(any)) {
        return (0, _list_1.listOrSublistToLines)(any, indentTexts);
    }
    else if (std.isNoteLike(any)) {
        return (0, _noteLike_1.noteLikeToLines)(any, indentTexts);
    }
    else if (std.isNoteLikeStruct(any)) {
        return (0, _noteLike_1.noteLikeStructToLines)(any, indentTexts);
    }
    else if (std.isParagraphItem(any)) {
        return (0, _paragraphItem_1.paragraphItemToLines)(any, indentTexts);
    }
    else if (std.isPreamble(any)) {
        return (0, _preamble_1.preambleToLines)(any, indentTexts);
    }
    else if (std.isRemarks(any)) {
        return (0, _remarks_1.remarksToLines)(any, indentTexts);
    }
    else if (std.isTable(any)) {
        return (0, _tableStruct_1.tableToLines)(any, indentTexts);
    }
    else if (std.isTableStruct(any)) {
        return (0, _tableStruct_1.tableStructToLines)(any, indentTexts, { withControl: true });
    }
    else if (std.isColumn(any) || std.isSentence(any)) {
        lines.push(new line_1.OtherLine({
            range: null,
            indentTexts,
            controls: [],
            sentencesArray: (0, columnsOrSentences_1.columnsOrSentencesToSentencesArray)([any]),
            lineEndText: toCSTSettings_1.default.EOL,
        }));
    }
    else {
        throw new util_1.NotImplementedError(`anyToLines: ${any.tag}`);
    }
    // else { assertNever(any); }
    return lines;
};
exports.anyToLines = anyToLines;
exports.$any = factory_1.factory
    .withName("any")
    .choice(c => c
    .orSequence(s => s
    .and(r => r.choice(c => c
    // .or(() => $amendProvision) // Same as (Sentence | Column)[]
    .or(() => _arithFormula_1.default)
    .or(() => _article_1.default)
    .or(() => _articleGroup_1.default) // Resets indentation
    .or(() => _figStruct_1.$fig) // Capture before $figStruct
    .or(() => _figStruct_1.default)
    .or(() => _list_1.$list) // Capture before $tableStruct
    // .or(() => $note) // Same as $any
    // .or(() => $style) // Same as $any
    // .or(() => $format) // Same as $any
    .or(() => _noteLike_1.$noteStruct)
    .or(() => _noteLike_1.$styleStruct)
    .or(() => _noteLike_1.$formatStruct)
    .or(() => _preamble_1.default)
    .or(() => _remarks_1.default)
    .or(() => _tableStruct_1.default)
    .or(() => _paragraphItem_1.$requireControlParagraphItem)), "any")
    .action(({ any }) => ({ value: [any.value], errors: any.errors })))
    .or(r => r
    .oneMatch(({ item }) => {
    if (item.type === line_1.LineType.OTH) {
        return {
            value: (0, columnsOrSentences_1.sentencesArrayToColumnsOrSentences)(item.line.sentencesArray),
            errors: [],
        };
    }
    else {
        return null;
    }
})));
exports.default = exports.$any;
//# sourceMappingURL=$any.js.map